import { css } from '@emotion/react';
import { theme } from '../theme';
import { tokens } from '../tokens';
const sizeMap = {
    large: {
        sizing: '27px',
    },
    medium: {
        sizing: '24px',
    },
    small: {
        sizing: '18px',
    },
};
const baseTagStyle = css({
    '::before': {
        borderRadius: tokens.borderRadius.medium,
        content: '""',
        display: 'block',
        height: '100%',
        inset: 0,
        position: 'absolute',
        width: '100%',
        zIndex: 0,
    },
    alignItems: 'center',
    border: 0,
    borderRadius: tokens.borderRadius.medium,
    display: 'inline-flex',
    justifyContent: 'center',
    outline: 0,
    paddingLeft: '6px',
    paddingRight: 0,
    position: 'relative',
    textDecoration: 'none',
});
export function tagStyle({ disabled, hasRightPadding, isFocusVisible, isMediumClosable, size, variant, }) {
    // Set the styles as the default base colors or the specified accent variant
    const variantStyle = variant === 'base'
        ? {
            main: theme.background.contrastInverse,
            textOnColor: theme.text.inverse,
        }
        : theme[variant];
    return [
        baseTagStyle,
        css(Object.assign(Object.assign(Object.assign(Object.assign({ backgroundColor: variant === 'transparentGrey'
                ? variantStyle.subtler
                : variantStyle.main, color: variantStyle.textOnColor, fontSize: tokens.fontSizes[size], height: sizeMap[size].sizing }, (disabled && {
            cursor: 'default',
            opacity: tokens.opacity.medium,
            pointerEvents: 'none',
        })), { ':hover': {
                '& > span': {
                    opacity: 1,
                },
                '&::before': {
                    backgroundColor: theme.background.hoverStrong,
                },
                cursor: isMediumClosable ? 'default' : 'pointer',
            } }), (hasRightPadding && {
            paddingRight: '6px',
        })), (isFocusVisible && {
            outline: `2px solid ${theme.border.focusOutline}`,
        }))),
    ];
}
export const contentWrapperStaticStyle = css({
    alignItems: 'center',
    display: 'inline-flex',
    height: 'inherit',
    justifyContent: 'center',
    zIndex: tokens.zIndex.default,
});
export const iconStaticStyle = css({
    color: 'inherit',
    marginRight: tokens.spacingNew.tiny,
});
export const innerContentStaticStyle = css({
    color: 'inherit',
    fontSize: 'inherit',
    maxWidth: '164px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    userSelect: 'none',
    whiteSpace: 'nowrap',
});
export const countStaticStyle = css({
    color: 'inherit',
    fontSize: 'inherit',
    fontWeight: tokens.fontWeights.bold,
    paddingLeft: tokens.spacingNew.tiny,
    userSelect: 'none',
});
const closeButtonStaticStyle = css({
    ':disabled': {
        pointerEvents: 'none',
    },
    ':hover': {
        '::before': {
            background: 'none',
        },
        opacity: 1,
    },
    alignItems: 'center',
    border: 'none',
    color: 'inherit',
    display: 'inline-flex',
    flexShrink: 0,
    justifyContent: 'center',
    opacity: tokens.opacity.high,
    outline: 'none',
});
export function closeButtonStyle({ disabled, isButton, size, }) {
    return [
        closeButtonStaticStyle,
        css(Object.assign({ height: sizeMap[size].sizing, minWidth: sizeMap[size].sizing }, (!isButton && Object.assign({ alignSelf: 'baseline' }, (disabled && { pointerEvents: 'none' }))))),
    ];
}
